
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { company } from '@components/config/company/Details';
import { DefaultSeo, NextSeo } from 'next-seo';
import { NEXT_SEO_DEFAULT } from '../next-seo.config';
import { JsonLdOrg } from '@components/config/strucureData/OrganisationJsonLd';
import { JsonLdFaq } from '@components/config/strucureData/FaqJsonLd';
import { JsonLdReview } from '@components/config/strucureData/ReviewsJsonLd';
import Contact from '@pages/contact';

export default function Index() {
  return (
    <>
      <NextSeo
        title={`Contact Us | ${company.name}`}
        description="Get in touch with Shipley Central Taxis, your reliable taxi service in Shipley, Saltaire, Bingley, and more. Call us at 01274 595959 for prompt and trustworthy service."
        openGraph={{
          url: `${company.url}/contact`,
        }}
        canonical={`${company.url}/contact`}
      />
      <JsonLdOrg />
      <JsonLdFaq />
      <JsonLdReview />
      <div>
        <Contact />
      </div>
    </>
  );
}
